import './only-assist_custom_page.scss';
import React, {useEffect, useState} from "react";
import AlfaButton from "../alfabutton/alfabutton.component";
import appStoreIcon from "../../../../assets/images/Download_on_the_App_Store_Badge_RU_RGB_blk_100317.svg";
import googlePlayIcon from "../images/GetItOnGooglePlay_Badge_Web_color_Russian.png";
import appGalleryIcon from "../../../../assets/images/appgallery.svg";
import androidStep1 from './images/android-step-1.png';
import androidStep2 from './images/android-step-2.png';
import androidStep3 from './images/android-step-3.png';
import androidStep4 from './images/android-step-4.png';
import androidStep5 from './images/android-step-5.png';
import iosStep1 from './images/ios-step-1.png';
import iosStep2 from './images/ios-step-2.png';
import iosStep3 from './images/ios-step-3.png';
import iosStep4 from './images/ios-step-4.png';
import iosStep5 from './images/ios-step-5.png';
import iosStep6 from './images/ios-step-6.png';
import iosStep7 from './images/ios-step-7.png';
import iosStep8 from './images/ios-step-8.png';
import windowsStep1 from './images/windows-step-1.png';
import windowsStep2 from './images/windows-step-2.png';
import windowsStep3 from './images/windows-step-3.png';
import windowsStep4 from './images/windows-step-4.png';
import windowsStep5 from './images/windows-step-5.png';
import windowsStep6 from './images/windows-step-6.png';
import macosStep1 from './images/macos-step-1.png';
import macosStep2 from './images/macos-step-2.png';
import macosStep3 from './images/macos-step-3.png';
import macosStep4 from './images/macos-step-4.png';
import macosStep5 from './images/macos-step-5.png';
import macosStep6 from './images/macos-step-6.png';
import macosStep7 from './images/macos-step-7.png';
import macosStep8 from './images/macos-step-8.png';

const certificateDevices = [
    {
        id: 'android',
        title: 'Android',
        content: <>
            <h4>Инструкция по&nbsp;установке сертификатов для&nbsp;Android</h4>
            <h4>Шаг&nbsp;1. Установите корневые сертификаты</h4>
            <ol>
                <li>Скачайте корневые сертификаты <a href="https://konsierge.com/files/android_russian_trusted_root_ca.zip" target="_blank" rel="noreferrer">Russian Trusted Root CA</a></li>
                <li>Распакуйте архив с&nbsp;файлами</li>
                <li>Откройте <strong>Настройки</strong> и&nbsp;найдите поиск. Введите <strong>Сертификат</strong> и&nbsp;выберите <strong>Сертификат CA</strong></li>
                <li>Если появится окно <strong>Укажите название сертификата</strong>, напишите там&nbsp;<strong>Russian Trusted Root CA</strong>, выберите <strong>VPN и&nbsp;приложения</strong> и&nbsp;нажмите <strong>ОК</strong></li>
                <li>Если появится предупреждение, нажмите <strong>Всё равно установить</strong>&nbsp;— это безопасно</li>
            </ol>
            <img src={androidStep1} alt="" />
            <p>Введите код-пароль от&nbsp;устройства или подтвердите личность по&nbsp;биометрии</p>
            <p>Нажмите на&nbsp;каждый из&nbsp;файлов на&nbsp;экране <strong>Загрузки</strong> по&nbsp;очереди:</p>
            <ul>
                <li>russian_trusted_root_ca.cer</li>
                <li>russian_trusted_root_ca_gost_2025.cer</li>
            </ul>
            <img src={androidStep2} alt="" />
            <p>После установки каждого сертификата вы&nbsp;увидите сообщение <strong>Сертификат ЦС&nbsp;установлен</strong>&nbsp;— значит, всё в&nbsp;порядке и&nbsp;вы&nbsp;установили выпускающие сертификаты</p>
            <h4>Шаг&nbsp;2. Установите выпускающие сертификаты</h4>
            <ol>
                <li>Скачайте выпускающие сертификаты <a href="https://konsierge.com/files/android_russian_trusted_sub_ca.zip" target="_blank" rel="noreferrer">Russian Trusted Sub CA</a></li>
                <li>Распакуйте архив с&nbsp;файлами</li>
                <li>Откройте <strong>Настройки</strong> и&nbsp;найдите поиск. Введите <strong>Сертификат</strong> и&nbsp;выберите <strong>Сертификат CA</strong></li>
                <li>Если появится окно <strong>Укажите название сертификата</strong>, напишите там&nbsp;<strong>Russian Trusted Sub CA</strong>, выберите <strong>VPN и&nbsp;приложения</strong> и&nbsp;нажмите <strong>ОК</strong></li>
                <li>Если появится предупреждение, нажмите <strong>Всё равно установить</strong>&nbsp;— это безопасно</li>
            </ol>
            <img src={androidStep3} alt="" />
            <p>Введите код-пароль от&nbsp;устройства или подтвердите личность по&nbsp;биометрии</p>
            <p>Нажмите на&nbsp;каждый из&nbsp;файлов на&nbsp;экране <strong>Загрузки</strong> по&nbsp;очереди:</p>
            <ul>
                <li>russian_trusted_sub_ca.cer</li>
                <li>russian_trusted_sub_ca_2024.cer</li>
                <li>russian_trusted_sub_ca_gost_2025.cer</li>
            </ul>
            <img src={androidStep4} alt="" />
            <p>После установки каждого сертификата вы&nbsp;увидите сообщение <strong>Сертификат ЦС&nbsp;установлен</strong>&nbsp;— значит, всё в&nbsp;порядке и&nbsp;вы&nbsp;установили выпускающие сертификаты</p>
            <div className="ac-cert-cache-note">
                <p>Обязательно очистите кэш вашего браузера, чтобы все онлайн‑сервисы открывались без&nbsp;ошибок</p>
                <p>Инструкция для <a href="https://support.google.com/accounts/answer/32050?hl=ru&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">Google Chrome</a> и&nbsp;<a href="https://support.mozilla.org/ru/kb/kak-udalit-kesh-firefox" target="_blank" rel="noreferrer">Mozilla Firefox</a></p>
            </div>
            <h4>Шаг&nbsp;3. Убедитесь, что всё в&nbsp;порядке</h4>
            <ol>
                <li>Откройте <strong>Настройки</strong> и&nbsp;найдите поиск</li>
                <li>Введите <strong>Надёжные сертификаты</strong> или <strong>Надёжные учётные данные</strong></li>
                <li>Откройте вкладку <strong>Пользователь</strong> и&nbsp;проверьте, чтобы там&nbsp;были сертификаты <strong>Russian Trusted Root CA</strong> и&nbsp;<strong>Russian Trusted Sub CA</strong></li>
            </ol>
            <img src={androidStep5} alt="" />
        </>
    },
    {
        id: 'ios',
        title: 'iOS',
        content: <>
            <h4>Инструкция по&nbsp;установке сертификатов для&nbsp;iOS</h4>
            <h4>Шаг&nbsp;1. Установите профиль с&nbsp;сертификатами</h4>
            <ol>
                <li>Скачайте файл <a href="https://konsierge.com/files/russiantrusted.mobileconfig" target="_blank" rel="noreferrer">russiantrusted.mobileconfig</a> через браузер Safari</li>
                <li>Нажмите <strong>Разрешить</strong>. Если у&nbsp;вас несколько устройств, выберите то, на&nbsp;которое нужно загрузить профиль</li>
            </ol>
            <img src={iosStep1} alt="" />
            <p>Откройте <strong>Настройки</strong> и&nbsp;нажмите <strong>Профиль загружен</strong></p>
            <img src={iosStep2} alt="" />
            <p>Нажмите <strong>Установить</strong>. Если не&nbsp;сделать этого сразу&nbsp;же после загрузки, система удалит профиль и&nbsp;его придётся скачивать снова</p>
            <img src={iosStep3} alt="" />
            <p>Введите код-пароль от&nbsp;устройств</p>
            <p>Нажмите <strong>Установить</strong> в&nbsp;окне с&nbsp;предупреждением, а&nbsp;затем <strong>Готово</strong></p>
            <img src={iosStep4} alt="" />
            <h4>Шаг&nbsp;2. Включите доверие сертификатам</h4>
            <p>Откройте <strong>Настройки → Основные → Об&nbsp;этом устройстве</strong></p>
            <img src={iosStep5} alt="" />
            <p>Пролистайте экран до&nbsp;конца и&nbsp;нажмите <strong>Доверие сертификатам</strong></p>
            <img src={iosStep6} alt="" />
            <p>Передвиньте переключатель справа от&nbsp;<strong>Russian Trusted Root CA</strong> в&nbsp;активное положение</p>
            <img src={iosStep7} alt="" />
            <p>Нажмите <strong>Продолжить</strong> в&nbsp;окне <strong>Корневой сертификат</strong></p>
            <img src={iosStep8} alt="" />
            <p>Готово, вы&nbsp;установили сертификаты</p>
            <div className="ac-cert-cache-note">
                <p>Обязательно очистите кэш вашего браузера, чтобы все онлайн‑сервисы открывались без&nbsp;ошибок</p>
                <p>Инструкция для <a href="https://support.apple.com/ru-ru/guide/iphone/iphacc5f0202/ios" target="_blank" rel="noreferrer">Safari</a>, <a href="https://support.google.com/accounts/answer/32050?hl=ru&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">Google Chrome</a> и <a href="https://support.mozilla.org/ru/kb/kak-udalit-kesh-firefox" target="_blank" rel="noreferrer">Mozilla Firefox</a></p>
            </div>
        </>
    },
    {
        id: 'windows',
        title: 'Windows',
        content: <>
            <h4>Инструкция по&nbsp;установке сертификатов для&nbsp;Windows</h4>
            <h4>Шаг&nbsp;1. Установите корневые сертификаты</h4>
            <ol>
                <li>Скачайте корневые сертификаты <a href="https://konsierge.com/files/windows_russian_trusted_root_ca.zip" target="_blank" rel="noreferrer">Russian Trusted Root CA</a></li>
                <li>Откройте папку <strong>Загрузки</strong> и распакуйте архив</li>
                <li>Откройте файл <strong>russian_trusted_root_ca.cer</strong> и&nbsp;нажмите <strong>Установить сертификат</strong></li>
            </ol>
            <img src={windowsStep1} alt="" />
            <p>Выберите <strong>Текущий пользователь</strong> в&nbsp;окне <strong>Мастер импорта сертификатов</strong>. Нажмите <strong>Далее</strong></p>
            <img src={windowsStep2} alt="" />
            <p>Выберите <strong>Поместить все сертификаты в&nbsp;следующее хранилище → Обзор → Доверенные корневые центры сертификации → Далее</strong></p>
            <img src={windowsStep3} alt="" />
            <p>Нажмите <strong>Готово → ОК</strong> в&nbsp;окне <strong>Завершение мастера импорта сертификатов</strong>. Если появится предупреждение системы безопасности, нажмите <strong>Да</strong></p>
            <p>Откройте файл <strong>russian_trusted_root_ca_gost_2025.cer</strong> и&nbsp;нажмите <strong>Установить сертификат</strong></p>
            <p>Повторите все действия из&nbsp;пунктов 4&nbsp;и&nbsp;5</p>
            <h4>Шаг&nbsp;2. Установите выпускающие сертификаты</h4>
            <ol>
                <li>Скачайте выпускающие сертификаты <a href="https://konsierge.com/files/windows_russian_trusted_sub_ca.zip" target="_blank" rel="noreferrer">Russian Trusted Sub CA</a></li>
                <li>Откройте папку <strong>Загрузки</strong> и&nbsp;распакуйте архив</li>
                <li>Откройте файл <strong>russian_trusted_sub_ca.cer</strong> и&nbsp;нажмите <strong>Установить сертификат</strong></li>
            </ol>
            <img src={windowsStep4} alt="" />
            <p>Выберите <strong>Текущий пользователь</strong> в&nbsp;окне <strong>Мастер импорта сертификатов</strong>. Нажмите <strong>Далее → Автоматически выбрать хранилище на&nbsp;основе типа сертификата → Далее</strong></p>
            <img src={windowsStep5} alt="" />
            <p>Выберите <strong>Автоматически выбрать хранилище на&nbsp;основе типа сертификата</strong>. Нажмите <strong>Далее</strong></p>
            <img src={windowsStep6} alt="" />
            <p>Нажмите <strong>Готово → ОК</strong> в&nbsp;окне <strong>Завершение мастера импорта сертификатов</strong></p>
            <p>Откройте файл <strong>russian_trusted_sub_ca_2024.cer</strong> и&nbsp;нажмите <strong>Установить сертификат</strong></p>
            <p>Повторите все действия из&nbsp;пунктов 4&nbsp;и&nbsp;5</p>
            <p>Откройте файл <strong>russian_trusted_sub_ca_gost_2025.cer</strong> и&nbsp;нажмите <strong>Установить сертификат</strong></p>
            <p>Повторите все действия из&nbsp;пунктов 4&nbsp;и&nbsp;5</p>
            <p>Готово, вы&nbsp;установили сертификаты</p>
            <div className="ac-cert-cache-note">
                <p>Обязательно очистите кэш вашего браузера, чтобы все онлайн‑сервисы открывались без&nbsp;ошибок</p>
                <p>Инструкция для <a href="https://support.microsoft.com/ru-ru/edge/view-and-delete-browser-history-in-microsoft-edge" target="_blank" rel="noreferrer">Microsoft Edge</a>, <a href="https://support.google.com/accounts/answer/32050?hl=ru&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">Google Chrome</a> и <a href="https://support.mozilla.org/ru/kb/kak-udalit-kesh-firefox" target="_blank" rel="noreferrer">Mozilla Firefox</a></p>
            </div>
        </>
    },
    {
        id: 'macos',
        title: 'MacOS',
        content: <>
            <h4>Инструкция по&nbsp;установке сертификатов для&nbsp;MacOS</h4>
            <h4>Шаг&nbsp;1. Установите конфигурационные файлы</h4>
            <ol>
                <li>Скачайте архив <a href="https://konsierge.com/files/russiantrustedca.zip" target="_blank" rel="noreferrer">russiantrustedca</a></li>
                <li>Откройте папку <strong>Загрузки</strong>, распакуйте архив и&nbsp;нажмите на&nbsp;файл <strong>russiantrustedca2024.pem</strong></li>
                <li>Нажмите <strong>Добавить</strong> в новом окне — система откроет <strong>Связку ключей</strong>. Если появится ошибка, нажмите <strong>ОК</strong> и&nbsp;продолжите установку</li>
            </ol>
            <img src={macosStep1} alt="" />
            <p>Войдите по&nbsp;отпечатку пальца или с&nbsp;именем пользователя и&nbsp;паролем</p>
            <p>Нажмите <strong>Изменить связку ключей</strong></p>
            <img src={macosStep2} alt="" />
            <h4>Шаг&nbsp;2. Установите корневой сертификат</h4>
            <p>Нажмите <strong>Вход</strong> в&nbsp;меню слева и&nbsp;выберите вкладку <strong>Сертификаты</strong> в&nbsp;верхнем меню</p>
            <img src={macosStep3} alt="" />
            <p>Откройте файл <strong>Russian Trusted Root CA</strong> и&nbsp;нажмите <strong>Доверие</strong>. Если не&nbsp;видите файл в&nbsp;списке, вернитесь в&nbsp;<strong>Загрузки</strong> и&nbsp;нажмите <strong>russian_trusted_root_ca_gost_2025.cer</strong></p>
            <p>Выберите <strong>Всегда доверять</strong> напротив пункта <strong>Параметры использования сертификатов</strong>. Закройте окно</p>
            <img src={macosStep4} alt="" />
            <p>Введите имя пользователя и&nbsp;пароль, а&nbsp;потом нажмите <strong>Обновить настройки</strong></p>
            <img src={macosStep5} alt="" />
            <h4>Шаг&nbsp;3. Установите выпускающий сертификат</h4>
            <p>Нажмите <strong>Вход</strong> в&nbsp;левом меню <strong>Связки ключей</strong>, выберите вкладку <strong>Сертификаты</strong> в&nbsp;верхнем меню</p>
            <img src={macosStep6} alt="" />
            <p>Откройте файл <strong>Russian Trusted Sub CA</strong> и&nbsp;нажмите <strong>Доверие</strong>. Если не&nbsp;видите файл в&nbsp;списке, вернитесь в&nbsp;<strong>Загрузки</strong> и&nbsp;нажмите <strong>russian_trusted_sub_ca_gost_2025</strong></p>
            <p>Выберите <strong>Всегда доверять</strong> напротив пункта <strong>Параметры использования сертификатов</strong>. Закройте окно</p>
            <img src={macosStep7} alt="" />
            <p>Введите имя пользователя и&nbsp;пароль, а&nbsp;потом нажмите <strong>Обновить настройки</strong></p>
            <img src={macosStep8} alt="" />
            <p>Готово, вы&nbsp;установили сертификаты</p>
            <div className="ac-cert-cache-note">
                <p>Обязательно очистите кэш вашего браузера, чтобы все онлайн‑сервисы открывались без&nbsp;ошибок</p>
                <p>Инструкция для <a href="https://support.apple.com/ru-ru/guide/iphone/iphacc5f0202/ios" target="_blank" rel="noreferrer">Safari</a>, <a href="https://support.google.com/accounts/answer/32050?hl=ru&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">Google Chrome</a> и <a href="https://support.mozilla.org/ru/kb/kak-udalit-kesh-firefox" target="_blank" rel="noreferrer">Mozilla Firefox</a></p>
            </div>
        </>
    }
];

const whiteScreenHelpId = 'white-screen-help';

export default function OnlyAssistCustomPage() {
    const [openedCertificates, setOpenedCertificates] = useState<string[]>([]);

    useEffect(() => {
        document.body.style.backgroundColor = '#ECECEC';
    }, []);

    const toggleCertificate = (id: string) => {
        setOpenedCertificates((current) => current.includes(id)
            ? current.filter((item) => item !== id)
            : [...current, id]);
    };

    const openWhiteScreenHelp = () => {
        setOpenedCertificates((current) => current.includes(whiteScreenHelpId)
            ? current
            : [...current, whiteScreenHelpId]);

        window.setTimeout(() => {
            document.getElementById(whiteScreenHelpId)?.scrollIntoView({behavior: 'smooth', block: 'start'});
        }, 0);
    };

    return (
        <div className="ac-root">
            <section className="ac-hero">

                <div className="ac-hero-grid ac-hero-grid-solo">
                    <div className="ac-hero-copy">
                        <h1 className="ac-hero-h1">
                            <span className="ac-hero-h1-line">Консьерж-сервис</span>
                            <span className="ac-hero-h1-line ac-hero-mark">Альфа-Банка</span>
                        </h1>
                    </div>
                </div>
            </section>


            <section className="ac-steps">
                <div className="ac-white-screen-variants">
                    <button
                        type="button"
                        className="ac-white-screen-variant ac-white-screen-variant-accent"
                        onClick={openWhiteScreenHelp}
                    >
                        <span>Проблема с белым экраном?</span>
                        <span className="ac-white-screen-arrow" aria-hidden="true">→</span>
                    </button>
                </div>

                <div className="ac-steps-head">
                    <h2 className="ac-steps-h2">Несколько шагов, чтобы подключить</h2>
                </div>

                <div className="ac-step">
                    <div className="ac-step-num">01</div>
                    <div className="ac-step-body">
                        <h3 className="ac-step-h">Авторизуйтесь через&nbsp;Альфа&nbsp;ID (для&nbsp;iOS)</h3>
                        <p className="ac-step-p">
                            Если вы впервые регистрируетесь в&nbsp;консьерж-сервисе, необходимо пройти авторизацию
                        </p>
                        <AlfaButton/>
                        <div className="ac-certificates" id="certification">
                            <div className="ac-cert-protection">
                                <h3>
                                    При возникновении ошибки при нажатии на кнопку "Альфа ID" с незащищенным подключением Вам нужно предпринять следующие действия:
                                </h3>
                            </div>

                            <div className="ac-cert-protection">
                                <h3>Как защитить подключение</h3>
                                <div className="ac-cert-card-grid">
                                    <div className="ac-cert-card">
                                        <div className="ac-cert-card-title">Установите сертификаты безопасности от&nbsp;Минцифры</div>
                                        <p>Они помогут заходить в&nbsp;онлайн-сервисы банка через иностранные браузеры</p>
                                        <a className="ac-cert-button" href="#certificates-install">Установить</a>
                                    </div>
                                    <div className="ac-cert-card">
                                        <div className="ac-cert-card-title ac-cert-card-title-balanced">Пользуйтесь Яндекс Браузером</div>
                                        <p>Он&nbsp;уже поддерживает все нужные сертификаты</p>
                                        <a className="ac-cert-button" href="https://browser.yandex.ru/" target="_blank" rel="noreferrer">Скачать браузер</a>
                                    </div>
                                </div>
                            </div>

                            <div className="ac-cert-install" id="certificates-install">
                                <h3>Как установить российские сертификаты</h3>
                                <p>Найдите своё устройство и&nbsp;следуйте пошаговой инструкции</p>
                                <div className="ac-cert-spoilers">
                                    {certificateDevices.map((device) => {
                                        const isOpened = openedCertificates.includes(device.id);

                                        return <div className={isOpened ? 'ac-cert-spoiler open' : 'ac-cert-spoiler'} key={device.id}>
                                            <button type="button" onClick={() => toggleCertificate(device.id)}>
                                                <span>{device.title}</span>
                                                <span className="ac-cert-spoiler-icon" aria-hidden="true"></span>
                                            </button>
                                            {isOpened && <div className="ac-cert-spoiler-content">
                                                {device.content}
                                            </div>}
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ac-step">
                    <div className="ac-step-num">02</div>
                    <div className="ac-step-body">
                        <h3 className="ac-step-h">Скачайте приложение</h3>
                        <p className="ac-step-p">
                            Далее перейдите по&nbsp;ссылке ниже и&nbsp;скачайте приложение в&nbsp;нужном магазине
                        </p>
                        <p className="ac-step-p">
                            <div className="ac-store-row">
                                <a
                                    className="ac-store-btn"
                                    href='https://apps.apple.com/ru/app/konsierge/id946404265'
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={appStoreIcon} alt='app store'/>
                                </a>
                                <a
                                    className="ac-store-btn googleplay-store"
                                    href='https://play.google.com/store/apps/details?id=com.konsierge.assist.only'
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={googlePlayIcon} alt='google play'/>
                                </a>
                                <a
                                    className="googleplay-store"
                                    href='https://appgallery.huawei.ru/app/C111746769'
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={appGalleryIcon} alt='app gallery'/>
                                </a>
                            </div>
                        </p>
                    </div>
                </div>
            </section>
            <section className="ac-hero">
                <div className="ac-step-h">
                    Для скачивания приложения на&nbsp;Андроид нажмите кнопку: "Скачать APK"
                </div>
                <p className="ac-step-p">
                    На ваш смартфон загрузится установочный файл&nbsp;APK. После скачивания вам может потребоваться перейти
                    в&nbsp;раздел «Мои файлы» для установки
                </p>
                <div className="ac-step-h">
                    Откройте файл (он&nbsp;будет называться only-assist.apk) на&nbsp;телефоне и&nbsp;установите приложение
                </div>
                <p className="ac-step-p">
                    Нужно разрешить установку приложений из&nbsp;неизвестных источников. Если не&nbsp;получается – звоните или пишите, наши контакты ниже
                </p>
                <button
                    id="app_download_button"
                    onClick={() => window.open('https://link.konsierge.com/onlyassist')}
                >
                    Скачать АPK
                </button>
            </section>

            <section className="ac-white-screen-help" id={whiteScreenHelpId}>
                <div className="ac-cert-spoilers">
                    <div className={openedCertificates.includes(whiteScreenHelpId) ? 'ac-cert-spoiler open' : 'ac-cert-spoiler'}>
                        <button type="button" onClick={() => toggleCertificate(whiteScreenHelpId)}>
                            <span>Проблема с белым экраном?</span>
                            <span className="ac-cert-spoiler-icon" aria-hidden="true"></span>
                        </button>
                        {openedCertificates.includes(whiteScreenHelpId) && <div className="ac-cert-spoiler-content">
                            <p>
                                Если вы не смогли пройти авторизацию в приложении Only Assist и приложение зависло на белом экране, то надо выполнить ряд действий:
                            </p>
                            <ul>
                                <li>Обновить приложение Only Assist</li>
                                <li>
                                    Если у вас установлены сертификаты Минцифры или Яндекс Браузер, то вам необходимо вернуться в приложение и пройти там авторизацию
                                </li>
                                <li>
                                    Если у вас не установлены сертификаты Минцифры и нет Яндекс Браузера, то вы можете их установить, либо при верификации в браузере через Alfa ID согласиться с переходом с небезопасным соединением.
                                </li>
                            </ul>
                        </div>}
                    </div>
                </div>
            </section>

            <section className="ac-contact">
                <div className="ac-contact-inner">
                    <div className="ac-contact-emoji">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <circle cx="20" cy="20" r="18" fill="#FFD24A" />
                            <circle cx="14" cy="17" r="2" fill="#1B1B1D" />
                            <circle cx="26" cy="17" r="2" fill="#1B1B1D" />
                            <path d="M13 24c2 3 5 4.5 7 4.5S25 27 27 24" stroke="#1B1B1D" strokeWidth="2.4" strokeLinecap="round" fill="none" />
                        </svg>
                    </div>
                    <div className="ac-contact-copy">
                        <div className="ac-contact-h">Остались вопросы?</div>
                        <div className="ac-contact-sub">Мы на&nbsp;связи&nbsp;— в&nbsp;любой момент</div>
                    </div>
                    <div className="ac-contact-actions">
                        <a className="ac-contact-pill" href="tel:88005053139">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path d="M5 4h4l2 5-3 2c1 3 3 5 6 6l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" strokeWidth="2" />
                            </svg>
                            <span>8&nbsp;800&nbsp;505&nbsp;31&nbsp;39</span>
                        </a>
                        <a className="ac-contact-pill" href="mailto:ab@knsrg.ru">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" style={{top: 1}}>
                                <rect x="3" y="5" width="18" height="14" rx="2" strokeWidth="2" />
                                <path d="m3 7 9 6 9-6" strokeWidth="2" />
                            </svg>
                            <span>ab@knsrg.ru</span>
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
}
